import { Button } from '@ipfabric/ui-components/Button/Button';
import type { TabData } from 'components/DeviceView/deviceViewTypes';
import { useLocale } from 'containers/App/LocaleContext';
import type { DeviceDetailData } from 'containers/HostnameDetail/HostnameDetailContent';
import { type FC, memo } from 'react';
import { possibleToConnectProtocols } from 'utils/constants';
import { isDeviceDetailData } from '../helpers/isDeviceDetailData';

interface Props {
  tabData: TabData;
}

export const isConnectAvailable = (device: DeviceDetailData): boolean =>
  !!device.loginType &&
  !!(device.loginIpv4 || device.loginIpv6) &&
  !!device.loginPort &&
  possibleToConnectProtocols.includes(device.loginType.toLowerCase());

const BareDeviceViewContentConnectButton: FC<Props> = (props) => {
  const msg = useLocale();
  if (!props.tabData) {
    return null;
  }
  const {
    tabData: { device },
  } = props;

  if (isDeviceDetailData(device) && isConnectAvailable(device)) {
    const loginIp = device.loginIpv4 || device.loginIpv6; // either one is always defined
    return (
      <Button
        renderAs='anchor'
        className='mr-1'
        href={`${device.loginType}://${loginIp}:${device.loginPort}`}
        icon='fa-plug'
        size='small'
        variant='plain'
      >
        {msg.deviceView.btnConnect}
      </Button>
    );
  }
  return null;
};

export const DeviceViewContentConnectButton = memo(
  BareDeviceViewContentConnectButton,
);
